import { render } from "./OutputOperate.vue?vue&type=template&id=5bb5fad7&scoped=true"
import script from "./OutputOperate.vue?vue&type=script&lang=js"
export * from "./OutputOperate.vue?vue&type=script&lang=js"

import "./OutputOperate.vue?vue&type=style&index=0&id=5bb5fad7&lang=scss&scoped=true"

import exportComponent from "D:\\部署项目\\电商\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bb5fad7"]])

export default __exports__